import React from 'react'
import NotFound from 'src/assets/images/404.svg'
import Accounts from 'src/assets/images/Accounts.svg'
import AccountsGrayscale from 'src/assets/images/AccountsGrayscale.svg'
import AddExpense from 'src/assets/images/AddExpense.svg'
import BudgetTypeRecurringGrayScale from 'src/assets/images/Budget-Recurring-Grayscale.svg'
import BudgetTypeStandardGrayScale from 'src/assets/images/Budget-Standard-Grayscale.svg'
import BudgetTypeRecurring from 'src/assets/images/BudgetType-Recurring.svg'
import BudgetTypeStandard from 'src/assets/images/BudgetType-Standard.svg'
import CardTypeDirect from 'src/assets/images/CardType-Direct.svg'
import CardTypeMultiple from 'src/assets/images/CardType-Multiple.svg'
import CardTypeMultipleGrayScale from 'src/assets/images/CardType-Multiple-Grayscale.svg'
import CardTypeRecurring from 'src/assets/images/CardType-Recurring.svg'
import CardTypeRecurringGrayScale from 'src/assets/images/CardType-Recurring-Grayscale.svg'
import CardTypeRecurringGuestGrayScale from 'src/assets/images/CardType-Recurring-Guest-Grayscale.svg'
import CardTypeRecurringGuest from 'src/assets/images/CardType-RecurringGuest.svg'
import CardTypeStandard from 'src/assets/images/CardType-Standard.svg'
import CardTypeStandardGrayScale from 'src/assets/images/CardType-Standard-Grayscale.svg'
import CardTypeDirectGrayScale from 'src/assets/images/CardType-Standard-Guest-Grayscale.svg'
import HomescreenAccountAccent from 'src/assets/images/HomescreenAccountAccent.svg'
import HomescreenAccountAccentGrayscale from 'src/assets/images/HomescreenAccountAccent-Grayscale.svg'
import HomescreenCardAccent from 'src/assets/images/HomescreenCardAccent.svg'
import HomescreenCardAccentGrayscale from 'src/assets/images/HomescreenCardAccent-Grayscale.svg'
import List from 'src/assets/images/List.svg'
import ListAutomation from 'src/assets/images/ListAutomation.svg'
import ListAutomationGrayscale from 'src/assets/images/ListAutomationGrayscale.svg'
import ListGrayscale from 'src/assets/images/ListGrayscale.svg'
import ListSearch from 'src/assets/images/ListSearch.svg'
import ListSearchGrayscale from 'src/assets/images/ListSearchGrayscale.svg'
import NoBudgets from 'src/assets/images/NoBudgets.svg'
import NoBudgetsGrayScale from 'src/assets/images/NoBudgets-Grayscale.svg'
import NoNotes from 'src/assets/images/NoNotes.svg'
import NoNotesGrayScale from 'src/assets/images/NoNotes-Grayscale.svg'
import NoSource from 'src/assets/images/NoSource.svg'
import NoSourceGrayScale from 'src/assets/images/NoSource-Grayscale.svg'
import NotFoundGrayscale from 'src/assets/images/NotFoundGrayscale.svg'
import NothingToReview from 'src/assets/images/NothingToReview.svg'
import NoTransactions from 'src/assets/images/NoTransactions.svg'
import NoTransactionsGrayScale from 'src/assets/images/NoTransactions-Grayscale.svg'
import NoVirtualCards from 'src/assets/images/NoVirtualCards.svg'
import NoVirtualCardsGrayScale from 'src/assets/images/NoVirtualCards-Grayscale.svg'
import OrganizationInvite from 'src/assets/images/OrganizationInvite.svg'
import OrganizationInviteGrayscale from 'src/assets/images/OrganizationInviteGrayscale.svg'
import Profile from 'src/assets/images/Profile.svg'
import ProfileGrayscale from 'src/assets/images/Profile-Grayscale.svg'
import ReceiptUpload from 'src/assets/images/ReceiptUpload.svg'
import ReceiptUploadGrayscale from 'src/assets/images/ReceiptUploadGrayscale.svg'
import Transaction from 'src/assets/images/Transaction.svg'
import TransactionGrayscale from 'src/assets/images/Transaction-Grayscale.svg'
import VirtualCard from 'src/assets/images/VirtualCard.svg'
import VirtualCardGrayscale from 'src/assets/images/VirtualCardGrayscale.svg'
import Account from 'src/assets/svgs/Account.svg'
import AccountGrayscale from 'src/assets/svgs/Account-Grayscale.svg'
import AccountsEmptyState from 'src/assets/svgs/AccountsEmptyState.svg'
import AccountsEmptyStateGrayscale from 'src/assets/svgs/AccountsEmptyState-Grayscale.svg'
import APIProductEmptyState from 'src/assets/svgs/APIProductEmptyState.svg'
import APIProductEmptyStateGrayscale from 'src/assets/svgs/APIProductEmptyStateGrayscale.svg'
import Buildings from 'src/assets/svgs/Buildings.svg'
import DepartmentsEmptyState from 'src/assets/svgs/DepartmentsEmptyState.svg'
import DepartmentsEmptyStateGrayscale from 'src/assets/svgs/DepartmentsEmptyState-Grayscale.svg'
import HomescreenOrgAccent from 'src/assets/svgs/HomescreenOrgAccent.svg'
import HomescreenOrgAccentGrayscale from 'src/assets/svgs/HomescreenOrgAccent-Grayscale.svg'
import NoOOPE from 'src/assets/svgs/NoOOPE.svg'
import NoOOPEGrayscale from 'src/assets/svgs/NoOOPE-Grayscale.svg'
import SvgDepartmentsEmptyState from 'src/components/Svgs/SvgDepartmentsEmptyState'
import SvgDepartmentsEmptyStateGrayscale from 'src/components/Svgs/SvgDepartmentsEmptyStateGrayscale'
import SvgEmptyStateChart from 'src/components/Svgs/SvgEmptyStateChart'
import SvgEmptyStateChartGrayscale from 'src/components/Svgs/SvgEmptyStateChartGrayscale'
import SvgExpensePopup from 'src/components/Svgs/SvgExpensePopup'
import SvgHomescreenTopMetricsAccent from 'src/components/Svgs/SvgHomescreenTopMetricsAccent'
import SvgHomescreenTopMetricsGrayscale from 'src/components/Svgs/SvgHomescreenTopMetricsGrayscale'
import SvgInviteGuest from 'src/components/Svgs/SvgInviteGuest'
import SvgInviteGuestGrayscale from 'src/components/Svgs/SvgInviteGuestGrayscale'
import SvgNoUsers from 'src/components/Svgs/SvgNoUsers'
import SvgNoUsersGrayscale from 'src/components/Svgs/SvgNoUsersGrayscale'
import SvgVirtualCardAndBudget from 'src/components/Svgs/SvgVirtualCardAndBudget'
import SvgVirtualCardAndBudgetGrayscale from 'src/components/Svgs/SvgVirtualCardAndBudgetGrayscale'
import { ImageNames, svgImageNames } from 'src/enums'
import { css } from 'styled-components'

export const returnImage = (
  imageName: ImageNames,
  grayScale?: boolean,
): string => {
  switch (imageName) {
    case ImageNames.Account: {
      if (grayScale) {
        return AccountGrayscale
      } else {
        return Account
      }
    }
    case ImageNames.Accounts: {
      if (grayScale) {
        return AccountsGrayscale
      } else {
        return Accounts
      }
    }
    case ImageNames.HomescreenCardAccent: {
      if (grayScale) {
        return HomescreenCardAccentGrayscale
      } else {
        return HomescreenCardAccent
      }
    }
    case ImageNames.HomescreenAccountAccent: {
      if (grayScale) {
        return HomescreenAccountAccentGrayscale
      } else {
        return HomescreenAccountAccent
      }
    }
    case ImageNames.HomescreenOrgAccent: {
      if (grayScale) {
        return HomescreenOrgAccentGrayscale
      } else {
        return HomescreenOrgAccent
      }
    }
    case ImageNames.CardTypeStandard: {
      if (grayScale) {
        return CardTypeStandardGrayScale
      } else {
        return CardTypeStandard
      }
    }
    case ImageNames.CardTypeRecurring: {
      if (grayScale) {
        return CardTypeRecurringGrayScale
      } else {
        return CardTypeRecurring
      }
    }
    case ImageNames.CardTypeGuest: {
      if (grayScale) {
        return CardTypeDirectGrayScale
      } else {
        return CardTypeDirect
      }
    }
    case ImageNames.CardTypeRecurringGuest: {
      if (grayScale) {
        return CardTypeRecurringGuestGrayScale
      } else {
        return CardTypeRecurringGuest
      }
    }
    case ImageNames.CardTypeMultiple: {
      if (grayScale) {
        return CardTypeMultipleGrayScale
      } else {
        return CardTypeMultiple
      }
    }
    case ImageNames.BudgetStandardActive: {
      if (grayScale) {
        return BudgetTypeStandardGrayScale
      } else {
        return BudgetTypeStandard
      }
    }
    case ImageNames.BudgetRecurringActive: {
      if (grayScale) {
        return BudgetTypeRecurringGrayScale
      } else {
        return BudgetTypeRecurring
      }
    }
    case ImageNames.NoBudgets: {
      if (grayScale) {
        return NoBudgetsGrayScale
      } else {
        return NoBudgets
      }
    }
    case ImageNames.NoNotes: {
      if (grayScale) {
        return NoNotesGrayScale
      } else {
        return NoNotes
      }
    }
    case ImageNames.NoSource: {
      if (grayScale) {
        return NoSourceGrayScale
      } else {
        return NoSource
      }
    }
    case ImageNames.NoTransactions: {
      if (grayScale) {
        return NoTransactionsGrayScale
      } else {
        return NoTransactions
      }
    }
    case ImageNames.NoVirtualCards: {
      if (grayScale) {
        return NoVirtualCardsGrayScale
      } else {
        return NoVirtualCards
      }
    }
    case ImageNames.AccountsEmptyState: {
      if (grayScale) {
        return AccountsEmptyStateGrayscale
      } else {
        return AccountsEmptyState
      }
    }
    case ImageNames.BuildingsPeople: {
      if (grayScale) {
        return DepartmentsEmptyStateGrayscale
      } else {
        return DepartmentsEmptyState
      }
    }
    case ImageNames.APIProductEmptyState: {
      if (grayScale) {
        return APIProductEmptyStateGrayscale
      } else {
        return APIProductEmptyState
      }
    }
    case ImageNames.List: {
      if (grayScale) {
        return ListGrayscale
      } else {
        return List
      }
    }
    case ImageNames.ListSearch: {
      if (grayScale) {
        return ListSearchGrayscale
      } else {
        return ListSearch
      }
    }
    case ImageNames.ListAutomation: {
      if (grayScale) {
        return ListAutomationGrayscale
      } else {
        return ListAutomation
      }
    }
    case ImageNames.NoOOPE: {
      if (grayScale) {
        return NoOOPEGrayscale
      } else {
        return NoOOPE
      }
    }
    case ImageNames.ReceiptUpload: {
      if (grayScale) {
        return ReceiptUploadGrayscale
      } else {
        return ReceiptUpload
      }
    }
    case ImageNames.VirtualCard: {
      if (grayScale) {
        return VirtualCardGrayscale
      } else {
        return VirtualCard
      }
    }
    case ImageNames.NotFound: {
      if (grayScale) {
        return NotFoundGrayscale
      } else {
        return NotFound
      }
    }
    case ImageNames.OrganizationInvite: {
      if (grayScale) {
        return OrganizationInviteGrayscale
      } else {
        return OrganizationInvite
      }
    }
    case ImageNames.Profile: {
      if (grayScale) {
        return ProfileGrayscale
      } else {
        return Profile
      }
    }
    case ImageNames.AddExpense: {
      if (grayScale) {
        return ''
      } else {
        return AddExpense
      }
    }
    case ImageNames.Transaction: {
      if (grayScale) {
        return TransactionGrayscale
      } else {
        return Transaction
      }
    }
    case ImageNames.Buildings: {
      if (grayScale) {
        return ''
      } else {
        return Buildings
      }
    }
    case ImageNames.NothingToReview: {
      if (grayScale) {
        return ''
      } else {
        return NothingToReview
      }
    }

    default: {
      throw new Error('Invalid image name')
    }
  }
}

export const returnSvgComponent = (
  imageName: svgImageNames,
  grayScale?: boolean,
): React.ReactElement => {
  switch (imageName) {
    case svgImageNames.NoUsers: {
      if (grayScale) {
        return <SvgNoUsersGrayscale />
      } else {
        return <SvgNoUsers />
      }
    }
    case svgImageNames.NoSpend: {
      if (grayScale) {
        return <SvgEmptyStateChartGrayscale />
      } else {
        return <SvgEmptyStateChart />
      }
    }
    case svgImageNames.NoAccountsOrBudgets: {
      if (grayScale) {
        return <SvgVirtualCardAndBudgetGrayscale />
      } else {
        return <SvgVirtualCardAndBudget />
      }
    }
    case svgImageNames.HomescreenTopMetricsAccent: {
      if (grayScale) {
        return <SvgHomescreenTopMetricsGrayscale />
      } else {
        return <SvgHomescreenTopMetricsAccent />
      }
    }
    case svgImageNames.BuildingsPeople: {
      if (grayScale) {
        return <SvgDepartmentsEmptyStateGrayscale />
      } else {
        return <SvgDepartmentsEmptyState />
      }
    }
    case svgImageNames.InviteGuest: {
      if (grayScale) {
        return <SvgInviteGuestGrayscale />
      } else {
        return <SvgInviteGuest />
      }
    }
    case svgImageNames.ExpenseTopRight: {
      if (grayScale) {
        return <div></div>
      } else {
        return (
          <SvgExpensePopup
            css={css`
              position: absolute;
              border-top-right-radius: 10px;
              top: 0px;
              right: 0px;
            `}
          />
        )
      }
    }
    default: {
      return <div></div>
    }
  }
}
